import React, { useMemo } from "react";
import { Select, MenuItem, Box } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { useChannels } from "../../hooks/useChannels";
import { getChannelIcon } from "../../utils/utils";

export const INTERNAL_NOTE_CHANNEL_ID = "internal_note";

const ChannelSelector = ({ selectedChannel, setSelectedChannel }) => {
  const { data: channelsData } = useChannels();

  const normalizeValue = (value) => {
    if (value === null || value === undefined) return "";
    if (value === 0 || value === "0") return "";
    return value;
  };

  const channelOptions = useMemo(() => {
    const fromApi = (channelsData?.channels ?? []).map((channel) => ({
      value: channel.id,
      label: channel.nome,
      icon: getChannelIcon(channel.nome, channel.channelType),
    }));
    return [
      { value: INTERNAL_NOTE_CHANNEL_ID, label: "Anotações internas", icon: <EditNoteIcon fontSize="small" /> },
      ...fromApi,
    ];
  }, [channelsData]);

  const normalizedSelectedChannel = normalizeValue(selectedChannel);
  const valueInOptions = channelOptions.some(
    (opt) =>
      String(opt.value) === String(normalizedSelectedChannel) ||
      (opt.value !== INTERNAL_NOTE_CHANNEL_ID && parseInt(opt.value) === parseInt(normalizedSelectedChannel))
  );
  const safeSelectValue = channelOptions?.length && valueInOptions
    ? normalizedSelectedChannel
    : (channelOptions?.[0]?.value ?? "");

  return (
    <Select
      value={safeSelectValue}
      onChange={(e) => setSelectedChannel(e.target.value)}
      size="small"
      MenuProps={{
        disableScrollLock: true,
        disablePortal: false,
        container: typeof document !== "undefined" ? document.body : undefined,
        sx: { zIndex: 200001 },
        PaperProps: { sx: { zIndex: 200002 } },
      }}
      sx={{
        minWidth: "32px",
        width: "40px",
        padding: 0,
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "& .MuiSelect-select": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "0 !important",
          margin: 0,
        },
        "& .MuiSelect-icon": {
          display: "none",
        },
      }}
      renderValue={() => {
        const selectedOption = channelOptions?.find(
          (opt) =>
            safeSelectValue !== "" &&
            (String(opt.value) === String(safeSelectValue) ||
              (opt.value !== INTERNAL_NOTE_CHANNEL_ID && parseInt(opt.value) === parseInt(safeSelectValue)))
        );
        return (
          selectedOption?.icon || (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {getChannelIcon("default", "default")}
            </Box>
          )
        );
      }}
    >
      {channelOptions?.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.icon}
          <Box sx={{ marginLeft: 1 }}>{option.label}</Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default ChannelSelector;
